import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase";
import "./admin.css";

export const AdminStatutPage = () => {
  const [headerImage, setHeaderImage] = useState("");
  const [description, setDescription] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [headerFile, setHeaderFile] = useState<File | null>(null);
  const [pdfFile, setPdfFile] = useState<File | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const refDoc = doc(db, "site_content", "statute_page");
      const snap = await getDoc(refDoc);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setDescription(data.description || "");
        setPdfUrl(data.pdf_url || "");
      }
    };
    fetchData();
  }, []);

  const uploadImage = async () => {
    if (!headerFile) return;
    const storageRef = ref(storage, `statute/banner_${Date.now()}`);
    const uploadTask = uploadBytesResumable(storageRef, headerFile);
    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setHeaderImage(url);
    });
  };

  const uploadPdf = async () => {
    if (!pdfFile) return;
    const storageRef = ref(storage, `statute/statut_${Date.now()}.pdf`);
    const uploadTask = uploadBytesResumable(storageRef, pdfFile);
    uploadTask.on("state_changed", undefined, console.error, async () => {
      const url = await getDownloadURL(uploadTask.snapshot.ref);
      setPdfUrl(url);
    });
  };

  const saveAll = async () => {
    await setDoc(doc(db, "site_content", "statute_page"), {
      header_image: headerImage,
      description,
      pdf_url: pdfUrl,
    });
    alert("Pagina de statut a fost salvată!");
  };

  return (
    <div className="admin-container">
      <h1>Administrare Pagina Statut</h1>

      <label>Imagine banner:</label>
      <input type="file" accept="image/*" onChange={(e) => setHeaderFile(e.target.files?.[0] || null)} />
      <button onClick={uploadImage}>Încarcă imagine</button>
      {headerImage && <img src={headerImage} alt="Header" className="preview-img" />}

      <label>Descriere:</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Descriere..."
      />

      <label>Fișier PDF Statut:</label>
      <input type="file" accept="application/pdf" onChange={(e) => setPdfFile(e.target.files?.[0] || null)} />
      <button onClick={uploadPdf}>Încarcă PDF</button>
      {pdfUrl && (
        <p>
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
            Vezi PDF actual
          </a>
        </p>
      )}

      <hr />
      <button className="save-btn" onClick={saveAll}>Salvează</button>
    </div>
  );
};
